import { render, staticRenderFns } from "./EditRecibo.vue?vue&type=template&id=0e65af79&scoped=true"
import script from "./EditRecibo.vue?vue&type=script&lang=js"
export * from "./EditRecibo.vue?vue&type=script&lang=js"
import style0 from "./EditRecibo.vue?vue&type=style&index=0&id=0e65af79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e65af79",
  null
  
)

export default component.exports